import http from "@/helper/http";
import {BaseVO, GetByIdBO, PaginationVO} from "@/model/global";
import {useMutation, useQuery} from "@tanstack/react-query";
import {ReviewStatusVO} from "@/service/instance.s";
import {PaybackPO} from "@/model/finance";
import {WritePaybackForm} from "@/pages/Payback/WritePayback";
import {ContractPO} from "@/model/customer";
import {ExecuteBO} from "@/service/instance.s";

export enum PaybackEnum {
    GetPaybackPage = "/payback/getPaybackPage",
    GetPayback = "/payback/getPayback",
    CreatePayback = "/payback/createPayback",
    UpdatePayback = "/payback/updatePayback",
    ConfirmPayback = '/payback/confirmPayback',
    SearchPayback = "/payback/searchPayback",
}

export interface PaybackPageBO {
    keyword?: string;
    flag?: string
}

export interface PaybackPageVO extends ReviewStatusVO, PaybackPO {
}

export interface PaybackVO extends PaybackPO {
    contract: ContractPO
}

export interface SearchPaybackBO {
    keyword: string;
}

export interface SearchPaybackVO {
    id: number
    customerName: string
}


export const useQueryPaybackPage = () => useMutation({
    mutationFn: (data: PaybackPageBO) => http.post<BaseVO<PaginationVO<PaybackPageVO>>>({
        url: PaybackEnum.GetPaybackPage,
        data: data,
    }),
})

export const useConfirmPayback = () => useMutation({
    mutationFn: (data: ExecuteBO) => http.post<BaseVO<null>>({url: PaybackEnum.ConfirmPayback, data}),
})

export const useCreatePayback = () => useMutation({
    mutationFn: (data: WritePaybackForm) => http.put({url: PaybackEnum.CreatePayback, data}),
})

export const useUpdatePayback = () => useMutation({
    mutationFn: (data: WritePaybackForm) => http.post({url: PaybackEnum.UpdatePayback, data}),
})

export const useQueryPayback = (params: GetByIdBO, enabled = true) => useQuery<BaseVO<PaybackVO>>({
    queryKey: [params.id], queryFn: () => http.get<BaseVO<PaybackVO>>({
        url: PaybackEnum.GetPayback,
        params: params
    }),
    enabled
})

export const useSearchPayback = () => useMutation({
    mutationFn: (data: SearchPaybackBO) => http.post<BaseVO<SearchPaybackVO[]>>({
        url: PaybackEnum.SearchPayback,
        data
    }),
})


